var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('VueApexCharts',{ref:`realtimeChart${_vm.windowId}`,attrs:{"type":"line","options":_vm.options,"series":_vm.series,"width":_vm.chartWidth,"height":_vm.chartHeight}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }